<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click.stop="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span /></td>
    <td class="no_padding">
      <input
        type="checkbox"
        :id="entity.id"
        :value="entity.id"
        @click.stop
        @change="onChange"
        :checked="isChecked"
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Bootcast ID' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Verze image' | translate">
        <a>{{ entity.image_version }}</a>
    </td>
    <td :data-th="'Verze splash' | translate">
      <a>{{ entity.splash_version }}</a>
    </td>
    <td :data-th="'Operátor' | translate">
      <a class="link" @click.stop="showOperatorDetail(entity.id_operator)">{{ entity.operator_name }}</a>
    </td>
    <td :data-th="'Zařízení' | translate">
      <a class="link" @click.stop="showDeviceDetail(entity.id_device)">{{ entity.device_name }}</a>
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteEntity">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import links from "../../mixins/links";

export default {
  name: 'DeviceBootConfigRow',
  mixins: [rowActions, links],
  props: {
    entity: Object,
    selectedEntities: Array,
  },
  data() {
    return {
      moduleName: 'deviceBootConfigs',
    }
  },
    methods: {
    goToDetail(e, id) {
      this.$router.push({name: 'deviceBootConfigDetail', params: {id: id}})
    },
    emitDeleteEntity() {
      this.$emit('deleteEntity', this.entity.id)
    },
    onChange: function (e) {
      this.$emit('input', e)
    },
  },
  computed: {
    isChecked() {
      return this.selectedEntities.indexOf(String(this.entity.id)) > -1
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceBootConfigs/DeviceBootConfigRow.vue